import { 
  collection, 
  addDoc, 
  getDocs, 
  getDoc, 
  doc, 
  query, 
  where, 
  orderBy, 
  limit,
  Timestamp 
} from 'firebase/firestore';
import { db } from './firebase';
import { Artwork, Category } from '../types';

export const createArtwork = async (artworkData: Omit<Artwork, 'id' | 'createdAt' | 'likes' | 'views'>) => {
  const artworkWithDefaults = {
    ...artworkData,
    createdAt: Timestamp.now(),
    likes: 0,
    views: 0,
  };
  
  const docRef = await addDoc(collection(db, 'artworks'), artworkWithDefaults);
  return docRef.id;
};

export const getArtworks = async (category?: Category, limitCount: number = 20) => {
  let q = query(
    collection(db, 'artworks'),
    orderBy('createdAt', 'desc'),
    limit(limitCount)
  );

  if (category && category !== 'All') {
    q = query(
      collection(db, 'artworks'),
      where('category', '==', category),
      orderBy('createdAt', 'desc'),
      limit(limitCount)
    );
  }

  const querySnapshot = await getDocs(q);
  return querySnapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data(),
    createdAt: doc.data().createdAt?.toDate() || new Date(),
  })) as Artwork[];
};

export const getArtworkById = async (id: string) => {
  const docRef = doc(db, 'artworks', id);
  const docSnap = await getDoc(docRef);
  
  if (docSnap.exists()) {
    return {
      id: docSnap.id,
      ...docSnap.data(),
      createdAt: docSnap.data().createdAt?.toDate() || new Date(),
    } as Artwork;
  }
  
  return null;
};

export const getArtworksByArtist = async (artistId: string) => {
  const q = query(
    collection(db, 'artworks'),
    where('artistId', '==', artistId),
    orderBy('createdAt', 'desc')
  );

  const querySnapshot = await getDocs(q);
  return querySnapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data(),
    createdAt: doc.data().createdAt?.toDate() || new Date(),
  })) as Artwork[];
};